import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/promises/selectors";
import { updatePromiseAsync } from "redux-toolkit/promises/actions";

const usePromiseVotes = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const handleVote = useCallback(
    (id, currentUserId, state) => {
      const data = {
        [`votes.${currentUserId}`]: state,
      };
      dispatch(
        updatePromiseAsync({
          id,
          data,
        }),
      );
    },
    [dispatch],
  );

  return {
    isLoading,
    handleVote,
  };
};

export default usePromiseVotes;
